import { Fragment } from 'react';
import { Button, IconButton, CircularProgress } from '@mui/material';
import { Save, Email, Download } from '@mui/icons-material';
import ResponseList from './ResponseList';
import NoCreatedEvent from '../../../user-dashboard/my-events/NoCreatedEvent';
import AnalyticsCard from '../../../../../components/Cards/AnalyticsCard';
import AlertDialog from '../../../../../components/Dialog/AlertDialog';
import useResponseManage from './hooks/useResponseManage';
import { Body1 } from '../../../../../themes/typography';
import '../../../../../styles/components/Invitation.css';

function ResponseManage({
    backToInviteTab = () => { }
}) {

    const {
        openExportModal,
        analyticsCards,
        invitations,
        setOpenExportModal,
        exportLoading,
        exportResponses,
        responseType,
    } = useResponseManage();

    return (
        <Fragment>
            <div className="manage-invitations-container">

                {invitations?.length > 0 && (
                    <div className="analytics-cards">
                        {analyticsCards.map((card, index) => (
                            <AnalyticsCard
                                key={index}
                                title={card.title}
                                value={card.value}
                                valueColor={card.valueColor}
                                iconBgColor={card.iconBgColor}
                                icon={card.icon}
                            />
                        ))}
                    </div>
                )}

                {invitations?.length > 0 && (
                    <div className='export-response-btns-container'>
                        <Button
                            endIcon={<Save />}
                            variant="text"
                            onClick={() => setOpenExportModal(true)}
                        >
                            Export
                        </Button>
                    </div>
                )}

                {invitations?.length > 0 && (
                    <ResponseList invitations={invitations} />
                )}

                {invitations?.length === 0 && (
                    <NoCreatedEvent
                        title="No responses yet!"
                        description='You have not received any responses from your invitations yet. Please check back later or send more invitations.'
                        btnName='Back to Invites'
                        onClick={backToInviteTab}
                        icon={<Email color="tertiary" sx={{ fontSize: '48px' }} />}
                    />
                )}
            </div>
            <AlertDialog
                open={openExportModal}
                onCancel={() => setOpenExportModal(false)}
                onConfirm={() => setOpenExportModal(false)}
                dialogTitle="Export Invitations Responses"
                primaryBtnName="OK"
                secondaryBtnName="Cancel"
                dialogId="export-responses-dialog"
            >

                <div className='export-response-download-container'>

                    {/* Export All Responses */}
                    <div className="export-response-option">
                        <Body1>
                            Export all responses.
                        </Body1>
                        <IconButton
                            color="secondary"
                            onClick={() => exportResponses('all')}
                        >
                            {responseType === 'all' && exportLoading
                                ? <CircularProgress
                                    size={20}
                                    sx={{ color: 'var(--secondary-color)' }}
                                />
                                : <Download />
                            }
                        </IconButton>
                    </div>

                    {/* Export Pending Responses */}
                    <div className="export-response-option">
                        <Body1>
                            Export the responses that are still pending.
                        </Body1>
                        <IconButton
                            color="secondary"
                            onClick={() => exportResponses('pending')}
                        >
                            {responseType === 'pending' && exportLoading
                                ? <CircularProgress
                                    size={20}
                                    sx={{ color: 'var(--secondary-color)' }}
                                />
                                : <Download />
                            }
                        </IconButton>
                    </div>

                    {/* Export Yes Responses */}
                    <div className="export-response-option">
                        <Body1>
                            Export the responses that are marked as "Yes".
                        </Body1>
                        <IconButton
                            color="secondary"
                            onClick={() => exportResponses('yes')}
                        >
                            {responseType === 'yes' && exportLoading
                                ? <CircularProgress
                                    size={20}
                                    sx={{ color: 'var(--secondary-color)' }}
                                />
                                : <Download />
                            }
                        </IconButton>
                    </div>

                    {/* Export No Responses */}
                    <div className="export-response-option">
                        <Body1>
                            Export the responses that are marked as "No".
                        </Body1>
                        <IconButton
                            color="secondary"
                            onClick={() => exportResponses('no')}
                        >
                            {responseType === 'no' && exportLoading
                                ? <CircularProgress
                                    size={20}
                                    sx={{ color: 'var(--secondary-color)' }}
                                />
                                : <Download />
                            }
                        </IconButton>
                    </div>
                </div>

            </AlertDialog>
        </Fragment>
    );
}

export default ResponseManage;